import { useProject } from '@builddocs/data-management'
import { AOSRType, DocumentEvents } from '@builddocs/filestore-api'
import { Notification, UserInfoBubble } from '@builddocs/mui'
import { SxProps } from '@mui/system'
import { format } from 'date-fns'
import isValid from 'date-fns/isValid'
import { ru } from 'date-fns/locale'

const calculateInitialDate = (aosr: AOSRType) => {
  const maxDateWorks = new Date(aosr?.endDate)

  const maxDateLabs =
    aosr?.laboratoriesObjList &&
    Object.values(aosr?.laboratoriesObjList).reduce((max, obj) => {
      const currentDate = new Date(obj.issueDate)

      return max
        ? currentDate > new Date(max)
          ? currentDate
          : new Date(max)
        : currentDate
    }, new Date(0))

  return maxDateWorks >= maxDateLabs ? maxDateWorks : maxDateLabs
}

export function AosrDateChangeNotice({
  act,
  projectId,
  sx,
}: {
  act: AOSRType
  projectId: string
  sx?: SxProps
}) {
  const { project } = useProject(projectId)

  // берем время изменения даты акта и автора
  const getChangedDateEventByIntegration = (
    documentEvents: DocumentEvents[],
  ) => {
    let changedDateEventIndex
    // @ts-expect-error старый typescript

    if (documentEvents.findLastIndex) {
      // @ts-expect-error старый typescript
      changedDateEventIndex = documentEvents.findLastIndex(
        event => event.type === 'MODIFIED_AOSR_ACT_DATE',
      )
    } else {
      const reversedArray = [...documentEvents].reverse()

      changedDateEventIndex =
        reversedArray.length -
        reversedArray.findIndex(
          event => event.type === 'MODIFIED_AOSR_ACT_DATE',
        ) -
        1
    }

    if (changedDateEventIndex === -1) {
      return null
    }

    return documentEvents[changedDateEventIndex - 1]?.type !==
      'ADDED_TO_CLOSING'
      ? documentEvents[changedDateEventIndex]
      : getChangedDateEventByIntegration(
          documentEvents.slice(0, changedDateEventIndex - 1),
        )
  }

  const changedDateEventByIntegration = getChangedDateEventByIntegration(
    act.documentHistory.documentEvents,
  )

  // дата акта, которая должна быть изначально, без изменения через интеграцию
  const initialDate = calculateInitialDate(act)
  const initialDateString = initialDate ? format(initialDate, 'dd.MM.yyyy') : ''

  // нынешняя дата акта
  const editedDate = new Date(act.actDate)
  const editedDateString = editedDate ? format(editedDate, 'dd.MM.yyyy') : ''

  return project?.integrations.includes('CHANGEABLE_AOSR_DATE') &&
    changedDateEventByIntegration &&
    initialDateString !== editedDateString ? (
    <Notification
      message={
        <>
          {`Дата акта была изменена с ${initialDateString} на ${editedDateString}`}
          <br />
          <UserInfoBubble
            labelProps={{ sx: { display: 'inline' } }}
            userId={changedDateEventByIntegration?.userId}
          />
          {'  '}
          {isValid(new Date(changedDateEventByIntegration?.dateTime)) &&
            format(
              new Date(changedDateEventByIntegration?.dateTime),
              'dd.MM.yyyy HH:mm',
              {
                locale: ru,
              },
            )}
        </>
      }
      sx={{
        marginBottom: '8px',
        ...sx,
      }}
    />
  ) : null
}
